import type { AnimationModeOpts } from "@/models/time-control/timeStateCtxTypes";

/**
 * Type guard: checks whether `modeOpts` has the animation shape.
 * Returns `true` when `startTime`/`endTime`/`temporalResolution` exist.
 */
export function isAnimationModeOpts(mo: AnimationModeOpts | any): mo is AnimationModeOpts {
  return !!mo && "startTime" in mo && "endTime" in mo && "temporalResolution" in mo;
}
